import auth from './api-client-url/auth'
import user from './api-client-url/user'
import company from './api-client-url/company'
import driver from './api-client-url/driver'
import vehicle from './api-client-url/vehicle'
import supply from './api-client-url/supply'
import settings from './api-client-url/settings'
import order from './api-client-url/order/index'
import booking from './api-client-url/booking'
import area from './api-client-url/area'
import companyGroup from './api-client-url/company-group'
import system from './api-client-url/system'
import commodity from './api-client-url/commodity'
import speedAssumptions from './api-client-url/speed-assumptions'
import salaryAssumptions from './api-client-url/salary-assumptions'
import customer from './api-client-url/customer'
import vendor from './api-client-url/vendor'
import companyBranch from './api-client-url/company-branch'
import notification from './api-client-url/notification'
import partner from './api-client-url/partner'
import cost from './api-client-url/cost'
import workflow from './api-client-url/workflow'
import routing from './api-client-url/routing'
import price from './api-client-url/price'
import quote from './api-client-url/quote'
import statistic from './api-client-url/statistic'
import activities from './api-client-url/activities'
import trip from './api-client-url/trip'
import analysis from './api-client-url/analysis'
import utils from './api-client-url/utils'
import journey from './api-client-url/journey'
import monitoring from './api-client-url/monitoring'
import report from './api-client-url/report'
import dashboard from './api-client-url/dashboard'
import route from './api-client-url/route'
import shared from './api-client-url/shared'

export default {
  auth,
  user,
  company,
  driver,
  vehicle,
  supply,
  settings,
  order,
  booking,
  area,
  companyGroup,
  system,
  commodity,
  speedAssumptions,
  salaryAssumptions,
  customer,
  companyBranch,
  notification,
  vendor,
  partner,
  cost,
  workflow,
  routing,
  price,
  quote,
  statistic,
  activities,
  trip,
  analysis,
  utils,
  journey,
  monitoring,
  report,
  dashboard,
  route,
  shared
}
